import { AfterViewInit, Component, Input, Output, EventEmitter, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FilterService } from 'src/app/services/filter.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-buffer-slider',
  templateUrl: './buffer-slider.component.html',
  styleUrls: ['./buffer-slider.component.scss']
})
export class BufferSliderComponent implements OnInit, AfterViewInit, OnDestroy {
  static key = 100612;
  label: string = 'BUFFER PERIOD (DAYS)';
  min: number = 0;
  max: number = 14;
  step: number = 1;
  value: number = 5;
  reqSubcription: Subscription[] = [];

  @Input() item: any;
  @Input() pageKey: any;
  @Output() onSizeChange = new EventEmitter<any>();
  @ViewChild('sliderContainer', { static: true }) sliderContainer!: ElementRef;

  constructor(public filterService: FilterService) {
    this.reqSubcription.push(
      this.filterService.bufferSlider.subscribe((query: any) => {
        this.disableBuffer(query);
      })
    );
  }

  ngOnInit() {
    const cfg = this.item?.config;

    // Default values from config
    this.label = cfg?.['label'] || this.label;
    this.min = cfg?.['min'] ?? this.min;
    this.max = cfg?.['max'] ?? this.max;
    this.step = cfg?.['step'] ?? this.step;
    this.value = cfg?.['value'] ?? this.value;
    const observer = new ResizeObserver((e: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(e[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.sliderContainer.nativeElement);

    // Check sessionStorage first
    const stored = sessionStorage.getItem('sliderState');
    if (stored) {
      try {
        const state = JSON.parse(stored);
        this.value = state.value ?? this.value;
        this.filterService.isBufferDisable = state.isBufferDisable ?? false;
      } catch (err) {
        console.error('Failed to parse sliderState from sessionStorage', err);
      }
    }

    // Sync with filterService
    this.filterService.buffer_days = this.value;
    this.filterService.baseQuery['buffer_days'] = this.value;
  }

  ngAfterViewInit(): void {}

  onValueChange(newValue: number) {
    this.value = newValue;
    this.filterService.buffer_days = newValue;
    this.filterService.baseQuery['buffer_days'] = newValue;
    this.filterService.filterQuery.next(this.filterService.baseQuery);

    // Save slider state
    sessionStorage.setItem(
      'sliderState',
      JSON.stringify({
        value: this.value,
        isBufferDisable: this.filterService.isBufferDisable
      })
    );
  }

  disableBuffer(disable: any) {
    const cfg = this.item?.config;

    if (disable) {
      this.value = 0;
      this.filterService.buffer_days = this.value;
      this.filterService.baseQuery['buffer_days'] = this.value;
      this.filterService.isBufferDisable = true;
    } else {
      this.value = cfg?.['value'] ?? this.value;
      this.filterService.buffer_days = this.value;
      this.filterService.baseQuery['buffer_days'] = this.value;
      this.filterService.isBufferDisable = false;
    }

    // Save the state whenever buffer is disabled/enabled
    sessionStorage.setItem(
      'sliderState',
      JSON.stringify({
        value: this.value,
        isBufferDisable: this.filterService.isBufferDisable
      })
    );
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
